module.exports = __webpack_public_path__ + "images/136f1c24d7d185390879d2af921d15d1-illu_newBox_GlassBreakSensor.png";